import React from 'react';

const PolicyHeader = () => {
    return (
        <div className="policy-header">
            <div className="policy-header-left">
                <h1>We want to protect you and your ideas.</h1>
                <p>
                    Agreeing to this states that you will not share or talk about other peoples
                    ideas shared on this platform.
                </p>
            </div>
            <div className="policy-header-right">
                <div>
                    <h3>Do&apos;s</h3>
                    <p>
                        {`Share ideas and campaigns you want help with. As a startup you can be open
                        since you're protected. No-one can talk about your new campaign ideas or
                        product features shared on this platform.`}
                    </p>
                    <p>
                        {`You don't have to donate but we highly encourage it, even if it's a small
                        amount. People take the time to give you their feedback.`}
                    </p>
                </div>
                <div>
                    <h3>Don&apos;ts</h3>
                    <p>We advise you not to post highly sensitive material on this platform.</p>
                    <p>
                        {`If users provide general answers to questions these can't be protected, only
                        specific ideas.`}
                    </p>
                </div>
            </div>
        </div>
    );
};

const PolicyPage = () => {
    return (
        <div className="scrollbar policy-page" id="style-4">
            <div className="force-overflow">
                <h5>Terms of Service</h5>
                <p>
                    Welcome to our Sidekick Network. By agreeing to these terms you’re agreeing to
                    not discuss or share ideas posted by other users, outside this platform, unless
                    given prior consent.
                </p>
                <p>
                    By using our network, you agree to comply with and be bound by the following
                    Terms of Service, which, together with our Privacy & Cookie Policy, govern
                    Sidekick Studio’s relationship with you in relation to this website. If you
                    disagree with any part of these Terms of Service, please do not use our website.
                </p>
                <p>
                    The term ‘Sidekick Studios’ or ‘us’ or ‘we’ refers to the owner of the
                    web-platform: https://sidekick-studios-network.web.app/signin
                </p>
                <p>The term ‘you’ refers to the user or viewer of our network.</p>
                <p>
                    The use of this network is subject to the following terms of use: The content of
                    the pages of this website is for your general information and use only. It is
                    subject to change without notice.
                </p>
                <p>
                    This website uses cookies. Please see our Privacy & Cookie Policy for further
                    information. Neither we, nor any third parties, provide any warranty or
                    guarantee as to the accuracy, timeliness, performance, completeness or
                    suitability of the information and materials found or offered on this website
                    for any particular purpose. You acknowledge that such information and materials
                    may contain inaccuracies or errors and we expressly exclude liability for any
                    such inaccuracies or errors to the fullest extent permitted by law.
                </p>
                <p>
                    Your use of any information or materials on this website is entirely at your own
                    risk, for which we shall not be liable. It shall be your own responsibility to
                    ensure that any products, services or information available through this website
                    meet your specific requirements.
                </p>
                <p>
                    This website contains material which is owned by or licensed to us. This
                    material includes, but is not limited to, the design, layout, look, appearance
                    and graphics. Reproduction is prohibited other than in accordance with the
                    copyright notice, which forms part of these Terms of Service. All trademarks
                    reproduced in this website which are not the property of, or licensed to, the
                    operator are acknowledged on the website.
                </p>
                <p>
                    Unauthorised use of this website may give rise to a claim for damages and/or be
                    a criminal offence.
                </p>
                <p>
                    From time to time this website may include links to other websites. These links
                    are provided for your convenience to provide further information. They do not
                    signify that we endorse the website(s). We have no responsibility for the
                    content of the linked website(s).
                </p>
                <p>
                    Your use of this website and any dispute arising out of such use of the website
                    is subject to the laws of England and Wales.
                </p>
                <h5>Privacy & Cookies Policy</h5>
                <p>
                    At Sidekick Studios (referred to as “Sidekick Studios”, “we”, “us”, “our”), we
                    understand that your privacy is important to you and that you care about how
                    your information is used and shared online. We respect and value the privacy of
                    everyone that visits our website and only collect and use information in ways
                    that are useful to you and in a manner consistent with your rights and our
                    obligations under the law, including the General Data Protection Regulation
                    (GDPR). This Privacy and Cookie Policy will help you understand how we process
                    any and all data collected by us in relation to your use of our website, and
                    what choices you have.
                </p>
                <h5>About Us</h5>
                <p>
                    Our website (https://sidekickstudios.co) is owned and operated by Sidekick
                    Studios. Any queries concerning data protection should be directed to Rupert
                    Mason, who can be contacted at rupert@sidekickstudios.co.
                </p>
                <h5>What information do we collect?</h5>
                <p>
                    We collect information about you when you complete a form on our website or when
                    you place an order with us for our products or services. We also collect
                    information when you voluntarily complete customer surveys, provide feedback,
                    participate in competitions and when you email us or contact us by telephone.
                    Website usage information is collected using cookies.
                </p>
                <h5>How will we use the information about you?</h5>
                <p>
                    We will use this information to provide the products or services requested, to
                    process your order, respond to communications from you and, if you agree, to
                    email you about other products and services that we think may be of interest to
                    you.
                </p>
                <p>
                    We use your information collected from our website to personalise your repeat
                    visits to our website. We will not share your information for marketing purposes
                    with companies outside of our organisation.
                </p>
                <h5>Marketing</h5>
                <p>
                    With your permission we would like to send you information about our products
                    and services, together with details of news and promotions that we think will be
                    of interest to you. We may use your data to contact you by email, telephone,
                    text message and by direct mail. You may opt out at any time.
                </p>
                <p>
                    If you no longer wish to be contacted for marketing purposes, please email
                    rupert@sidekickstudios.co. You can opt out of our email communications by
                    clicking the unsubscribe link at the footer of any email you receive from us.
                </p>
                <h5>How and where do we store your data?</h5>
                <p>
                    We only keep your data if we have a valid ​ legal reason to do so​ and will only
                    keep it for as long as we need to in order to fulfil our contractual or legal
                    obligations or for as long as we have your permission to keep it. Your data will
                    be deleted if we no longer need it to maintain our obligations or if you have
                    requested that we delete it.
                </p>
                <p>
                    Some or all of your data may be stored or transferred outside of the European
                    Economic Area (“the EEA”). If we do store or transfer data outside of the EEA,
                    we will take all reasonable steps to ensure that your data is treated as safely
                    and securely as it would within the EEA and under the GDPR.
                </p>
                <p>
                    Data security is of great importance to us. We take steps to protect your data
                    by using data encryption on our website. Our website is hosted in the US and is
                    monitored 24/7, 365 days a year. The server(s) where it is stored includes
                    firewall protection and secure monitoring software.
                </p>
                <h5>Access to your information and correction</h5>
                <p>
                    You have the right to request a copy of the information that we hold about you.
                    If you would like a copy of some, or all of your personal information, please
                    email us at rupert@sidekickstudios.co. There may be a small charge for this
                    service. We want to ensure that your personal information is accurate and up to
                    date. You may ask us to correct or remove information you think is inaccurate.
                </p>
                <h5>Cookies</h5>
                <p>
                    Cookies are text files placed on your computer to collect standard internet
                    information and visitor behaviour information. This information is used to track
                    visitor use of the website and to compile statistical reports on website
                    activity. It may also be used for the purpose of running re-marketing adverts to
                    you about our products and services. You can set your browser not to accept
                    cookies and can also remove cookies from your browser. However, if you do, some
                    features on our website may not function as a result. You can find out more
                    information about cookies and how to remove cookies by visiting
                    allaboutcookies.org​ .
                </p>
                <h5>Other websites</h5>
                <p>
                    Our website contains links to other websites. This Privacy and Cookie Policy
                    only applies to this website. So, if you follow a link to other websites you
                    should read their privacy policy.
                </p>
                <h5>Changes to our privacy policy</h5>
                <p>
                    Our Privacy and Cookie Policy will be reviewed from time to time and any updates
                    will be posted on this web page.
                </p>
                <h5>Contact Us</h5>
                <p>
                    If you have any queries concerning this Privacy and Cookie Policy, your personal
                    information or any questions regarding our use of the information, please email
                    us at rupert@sidekickstudios.co.
                </p>
            </div>
        </div>
    );
};

export { PolicyHeader, PolicyPage };
